import { Root } from "@radix-ui/react-accordion";
import type React from "react";

interface AccordionRootProps {
  className?: string;
  children: React.JSX.Element | React.JSX.Element[];
  collapsible?: boolean;
  runOnOpen?: () => void;
  runOnClose?: () => void;
  defaultValue?: string;
}

const AccordionRoot = ({
  className = "",
  children,
  collapsible = true,
  runOnOpen = () => {},
  runOnClose = () => {},
  defaultValue = undefined,
  ...props
}: AccordionRootProps) => {
  // This function is called when the accordion is opened or closed.
  // If itemOpen exists, the accordion is open. ItemOpen is a string
  // of the accordion's value that is open (the one passed to the
  // AccordionItem's value prop)
  const handleOnValueChange = (itemOpen: string) => {
    if (itemOpen) {
      runOnOpen();
    } else {
      runOnClose();
    }
  };

  return (
    <Root
      onValueChange={handleOnValueChange}
      collapsible={collapsible}
      type="single"
      className={className}
      defaultValue={defaultValue}
      {...props}
    >
      {children}
    </Root>
  );
};

export { AccordionRoot };
